var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.17882C12.4142 4.17882 12.75 4.51461 12.75 4.92882L12.75 11.2499L19.0711 11.2499C19.4853 11.2499 19.8211 11.5857 19.8211 11.9999C19.8211 12.4141 19.4853 12.7499 19.0711 12.7499L12.75 12.7499L12.75 19.071C12.75 19.4852 12.4142 19.821 12 19.821C11.5858 19.821 11.25 19.4852 11.25 19.071L11.25 12.7499L4.92893 12.7499C4.51472 12.7499 4.17893 12.4141 4.17893 11.9999C4.17893 11.5857 4.51472 11.2499 4.92893 11.2499L11.25 11.2499L11.25 4.92882C11.25 4.51461 11.5858 4.17882 12 4.17882Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPlus);
export default __webpack_public_path__ + "static/media/input-plus.df1c7e0d.svg";
export { ForwardRef as ReactComponent };